export const indicatorsLabels = ['Performance', 'Robustness', 'Fairness', 'Explainability'];
